import { useMemo } from 'react';
import { IBooking } from '@whitelabel/helpers/types';
import { getEsimEligibleBooking } from './bookings';
import useShowRCUpsellBanner from './useShowRCupsellBanner';

const useEligibleOffers = (bookings: IBooking[], id: string) => {
  const { showRCupsellBanner, isFetching, urlQueryObj, trackingData, latestTravelBookingID } = useShowRCUpsellBanner(
    bookings,
    id,
  );

  return useMemo(() => {
    const esimEligibleBooking = getEsimEligibleBooking(bookings);
    const showEsimOffer = !!esimEligibleBooking;
    const hasOffers = showRCupsellBanner || showEsimOffer;

    return {
      hasOffers,
      showEsimOffer,
      esimEligibleBooking,
      RCofferData: {
        showRCupsellBanner,
        urlQueryObj: urlQueryObj as Record<string, string>,
        trackingData,
        latestTravelBookingID,
        isFetching,
      },
    };
  }, [bookings, id, showRCupsellBanner, urlQueryObj, trackingData, latestTravelBookingID, isFetching]);
};

export default useEligibleOffers;
